import React, { useContext } from 'react';

import { FilterButton } from '../../FilterButton';
import DiscoveryContextV2 from '../../../../../contexts/discoveryContext/contextV2';
import ClearFilterButton from '../ClearFilterButton';
import { bold, count } from './styles.module.css';

const TagValueComponent = ({ modalOpen, clearFilter, ...props }) => {
  const {
    filters: {
      tag: { tags },
    },
  } = useContext(DiscoveryContextV2);

  const tagCount = (tags ?? []).length;
  const isActive = tagCount > 0;

  return (
    <FilterButton active={isActive || modalOpen} {...props}>
      <span className={isActive ? bold : undefined}>Filters</span>
      {isActive && (
        <>
          <span className={count}>{tagCount}</span>
          <ClearFilterButton onClick={clearFilter} />
        </>
      )}
    </FilterButton>
  );
};

export default TagValueComponent;
